<template lang="pug">
#app.layout.layout--default
  announcements-bar
  landing-header-bar

  #content
    nuxt

  landing-footer-bar.legacy
  cookie-consent-alert
</template>

<script>
import AnnouncementsBar from '~/components/menus/AnnouncementsBar'
import LandingHeaderBar from '~/components/menus/LandingHeaderBar'
import LandingFooterBar from '~/components/menus/LandingFooterBar'
import CookieConsentAlert from '~/components/menus/CookieConsentAlert'

export default {
  name: 'DefaultLayout',

  components: {
    AnnouncementsBar,
    LandingHeaderBar,
    LandingFooterBar,
    CookieConsentAlert
  }
}
</script>

<style lang="scss" scoped>
.layout {
  background: white;
}
</style>
